import { Grid } from "@material-ui/core";
import { useEspelhoFaturamentoService } from "../../context/EspelhoFaturamentoContext";
import ReportTable from "./ReportTable";

const ReportDataGrid = () => {
  const { columns, handleSort, isGrouped, cachedInvoicing } =
    useEspelhoFaturamentoService();

  const { data } = cachedInvoicing;
  const isEmpty = data.every((item) => !item.elements.length);

  if (isEmpty) {
    return (
      <Grid item xs={12} style={{ marginBottom: 16 }} key={"empty-table"}>
        <ReportTable
          data={[]}
          columns={columns}
          sort={handleSort}
          emptyMessage="Sem Movimentação"
        />
      </Grid>
    );
  }

  return (
    <Grid item container>
      <Grid item xs={12}>
        <ReportTable
          data={data}
          columns={columns}
          sort={handleSort}
          emptyMessage="Sem Movimentação"
          isGrouped={isGrouped}
        />
      </Grid>
    </Grid>
  );
};

export default ReportDataGrid;
